import React from 'react';
import { deleteDesiginationData, getDesiginationData } from '../../service/adminApi';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import { useNavigate, useParams } from 'react-router-dom';
import SideNavBar from '../SideNavBar/SideNavBar';
import { getTimestampToDate } from '../../utils/dateConvetor';
import Popup from '../ConformationPopup/Popup';

function Designation() {
    const navigate = useNavigate();
    const params = useParams();
    const [designationList, setDesignationList] = React.useState([]);
    const [editData, setEditData] = React.useState({});
    const [breadCrumbs, setBreadcrumbs] = React.useState([
        { title: 'Dashboard', path: '/Overview', isActive: true },
        { title: 'Admin', path: '/admin/accountbranding', isActive: true },
        { title: 'Recruitment Settings', path: '/admin/recuritementmessage', isActive: true },
        { title: 'Questionnaires - Experienced', path: '/admin/experiencequestions', isActive: true },
    ]);

    const [deleteIndex, setDeleteIndex] = React.useState();
    const [hideContainer, setHideContainer] = React.useState(true);

    React.useEffect(() => {
      
        getDesignationList(params.dId);
    }, [params]);

    const getDesignationList = async (id) => {
        let data = {
            department_id: id,
        };
        const response = await getDesiginationData(data);

        if (response.data.statusCode === 200) {
            if (breadCrumbs.length < 5) {
                let data = breadCrumbs;
                data.push({ title: response.data.data[0].department_name, path: '', isActive: false });
                setBreadcrumbs(data);
            } else if ((breadCrumbs.length = 5)) {
                let data = breadCrumbs;
                data[4] = { title: response.data.data[0].department_name, path: '', isActive: false };
                setBreadcrumbs(data);
            }
            setDesignationList(response.data.data);
        }
    };

    const handleDesignationNavigate = async (id) => {
        navigate(`eq/${id}`);
    };

    const deleteDesigination = async () => {
        const response = await deleteDesiginationData({ id: deleteIndex });
        if (response.data.statusCode === 200) {
            getDesignationList(params.dId);
        }
    };

    const renderDesignationList = () => {
        return (
            <div className="row">
                <ul className="list-unstyled my-2">
                    {designationList.map((designation, index) => {
                        let date = designation.lastModified !== '' ? getTimestampToDate(designation.lastModified, 3) : '';
                        return (
                            <li className="my-2 bg-white goal-li-sty py-3 px-3">
                                <div className="d-flex justify-content-between border-none bg-white">
                                    <div
                                        onClick={() => {
                                            handleDesignationNavigate(designation.id);
                                        }}
                                        className="col-md-3 d-flex align-self-center"
                                    >
                                        <div className="d-block align-self-center">
                                            <a className="text-deco-none">
                                                <img src="/Images/orange-arrow.svg" alt="orange-arrow" className="me-2" />
                                            </a>
                                        </div>
                                        <div className="ps-3">
                                            <h6 className="tt-bold font-15 policy-darkbluefont pt-2">{designation.role}</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-2 text-center align-self-center">
                                        <span className="status-btn bg-pastel-blue font-14">{designation.count} Question</span>
                                    </div>
                                    <div className="col-md-3 text-center align-self-center">
                                        <span className="status-btn font-grey font-14">
                                            {date !== '' || date !== undefined ? `Last Updated - ${date}` : ''}
                                        </span>
                                    </div>
                                    <div className="dropend me-4 align-self-center">
                                        <button
                                            type="button"
                                            className="btn p-0 align-self-center kebab-btn-sty"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <span>
                                                <img src="/Images/kebab-icon.svg" className="kebab-size" />
                                            </span>
                                        </button>
                                        <ul
                                            className="dropdown-menu dropdown-menu-end offboarding-card-dropdown border-0 shadow-sm"
                                            style={{}}
                                        >
                                            <li>
                                                <a
                                                    data-bs-toggle="offcanvas"
                                                    data-bs-target="#offcanvasRight"
                                                    aria-controls="offcanvasRight"
                                                    className="dropdown-item dditems semibold-text border-bottom font-12 fontcolor-1"
                                                    onClick={() => {
                                                        setEditData(designation);
                                                        setHideContainer(false);
                                                    }}
                                                >
                                                    Edit
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#logout"
                                                    onClick={() => {
                                                        setDeleteIndex(designation.id);
                                                    }}
                                                    className="dropdown-item dditems semibold-text fontcolor-1 font-12"
                                                >
                                                    Delete
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    const updateDesiginationData = (data) => {
        switch (data) {
            case 'cancel':
                setEditData();
                break;
            case 'update':
                getDesignationList(params.dId);
                break;
            default:
                break;
        }
    };

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbs} />
            {hideContainer == false ? (
                <SideNavBar
                    form={'DesignationForm'}
                    desiginationId={params.dId}
                    editData={editData}
                    handleData={(data) => {
                        updateDesiginationData(data);
                    }}
                    hideContainer={hideContainer}
                    setHideContainer={() => setHideContainer()}
                />
            ) : null}
            <div className="row">
                <div className="col-md-12">
                    <div className="d-flex justify-content-between">
                        <h5 className="bold-text tt-bold font-18">
                            <img
                                className="me-3"
                                onClick={() => {
                                    navigate('/admin/experiencequestions');
                                }}
                                src="/Images/back-arrow.svg"
                                alt="back arrow"
                            />
                            Questions - Experienced
                        </h5>
                        <a
                            className="btn hive-btn-primary"
                            type="button"
                            // data-bs-toggle="offcanvas"
                            // data-bs-target="#offcanvasRight"
                            // aria-controls="offcanvasRight"
                            onClick={() => setHideContainer(false)}
                        >
                            <img className="me-2" src="/Images/plus.svg" />
                            Desigination
                        </a>
                    </div>
                </div>
            </div>

            {renderDesignationList()}
            <Popup
                deleteData={() => {
                    deleteDesigination();
                }}
            />
        </div>
    );
}

export default Designation;
